import Vue from 'vue'
import Vuex from 'vuex'
import sbModule from './modules/admin/social-broadcasting/store'
import advocatesModule from './modules/admin/advocates-shared/store'
import advocatesNewModule from './modules/admin/advocates/store'
import importReportsModule from './modules/admin/importReports/store'
import adsModule from './modules/admin/ads/store'
import campaignsModule from './modules/admin/campaigns/store'

Vue.use(Vuex);

let addPost = (state, statePostsName, newPost) => {
    const idx = state[statePostsName].findIndex(existingPost => existingPost.id === newPost.id);

    //If the post is already in our list, update that post
    if (idx > -1) {
        //Use Object.assign so the reactivity gets triggered for the object
        state[statePostsName][idx] =  Object.assign(state[statePostsName][idx], newPost);
    } else {
        //Otherwise, create a new one
        state[statePostsName].push(newPost);
    }
};

//TODO: Break this into modules. Either the whole thing into a SB module, or into smaller modules
//Also look at implementing getters and actions to clean this up a bit
const options = {
    modules: {
        CAMP: campaignsModule,
        SB: sbModule,
        ADV: advocatesModule,
        ADS: adsModule,
        ADVNEW: advocatesNewModule,
        ADVIMPORT: importReportsModule,
    },
    state: {
        accounts: [],
        accountAccessDeleted: null,
        activePostDetail: {},
        accountListModified: false,
        broadcastedPosts: [],
        errorMessages: [],
        formLoading: false,
        initMediaInfo: '',
        scheduledBroadcastDateTime: '',
        scheduledBroadcastDateTimeChanged: false,
        postMediaInformation: {},
        scheduledDatetime: '',
        scheduledPosts: [],
        selectedAccounts: [],
        selectedCampaignId: null,
        showAccountsModal: false,
        showBotModal: false,
        showErrorMessage: false,
        showPostModal: false,
        showCustomFieldsModal: false,
        customFieldId: null,
        validPostDateAndTime: false
    },
    mutations: {
        accounts: (state, accounts) => {
            //Create a brand new array so the reactivity is triggered
            //Similar to how we do Object.assign, except for arrays.
            let newArray = [];
            let arrayLength = accounts.length;
            for(let i = 0; i < arrayLength; i++) {
                newArray.push(accounts[i]);
            }
            state.accounts = newArray;
        },
        accountAccessDeleted: (state, accountAccessDeleted) => {
            state.accountAccessDeleted = accountAccessDeleted;
        },
        accountListModified: (state, accountListModified) => {
            state.accountListModified = accountListModified;
        },
        activePostDetail: (state, activePostDetail) => {
            state.activePostDetail = activePostDetail;
        },
        addBroadcastedPost: (state, newBroadcastedPost) => {
            addPost(state, 'broadcastedPosts', newBroadcastedPost);
        },
        addErrorMessage: (state, errorMessage) => {
            state.errorMessages.push(errorMessage);
        },
        addScheduledPost: (state, newScheduledPost) => {
            addPost(state, 'scheduledPosts', newScheduledPost);
        },
        broadcastedPosts: (state, broadcastedPosts) => {
            state.broadcastedPosts = broadcastedPosts;
        },
        clearSelectedAccounts: (state) => {
            state.selectedAccounts = [];
        },
        deselectAccount: (state, account) => {
            let numSelectedAccounts = state.selectedAccounts.length;
            for (let i = 0; i < numSelectedAccounts; i++) {
                if (state.selectedAccounts[i].id === account.id) {
                    state.selectedAccounts.splice(i, 1);
                    break;
                }
            }
        },
        formLoading: (state, formLoading) => {
                state.formLoading = formLoading;
        },
        initMediaInfo: (state, initMediaInfo) => {
            state.initMediaInfo = initMediaInfo;
        },
        scheduledBroadcastDateTime: (state, scheduledBroadcastDateTime) => {
            state.scheduledBroadcastDateTime = scheduledBroadcastDateTime;
        },
        scheduledBroadcastDateTimeChanged: (state, scheduledBroadcastDateTimeChanged) => {
            state.scheduledBroadcastDateTimeChanged = scheduledBroadcastDateTimeChanged;
        },
        showErrorMessage: (state, showErrorMessage) => {
            state.showErrorMessage = showErrorMessage;
        },
        postMediaInformation: (state, postMediaInformation) => {
            state.postMediaInformation = postMediaInformation;
        },
        postScheduleInformation: (state, postScheduleInformation) => {
            state.postScheduleInformation = postScheduleInformation;
        },
        removeScheduledPost: (state, newPostId) => {
            const idx = state.scheduledPosts.findIndex(existingScheduledPost => existingScheduledPost.id === newPostId);

            //If the post exists in our list, remove it from the list of scheduled posts
            if (idx > -1) {
                state.scheduledPosts.splice(idx, 1);
            }
        },
        scheduledDatetime: (state, scheduledDatetime) => {
            state.scheduledDatetime = scheduledDatetime;
        },
        scheduledPosts: (state, scheduledPosts) => {
            state.scheduledPosts = scheduledPosts;
        },
        selectAccount: (state, account) => {
            state.selectedAccounts.push(account);
        },
        showAccountsModal: (state, showAccountsModal) => {
            state.showAccountsModal = showAccountsModal;
        },
        showBotModal: (state, showBotModal) => {
            state.showBotModal = showBotModal;
        },
        showPostModal: (state, showPostModal) => {
            state.showPostModal = showPostModal;
        },
        showCustomFieldsModal: (state, showCustomFieldsModal) => {
            state.showCustomFieldsModal = showCustomFieldsModal;
        },
        selectedCampaignId: (state, selectedCampaignId) => {
            state.selectedCampaignId = selectedCampaignId;
        },
        customFieldId: (state, customFieldId) => {
            state.customFieldId = customFieldId;
        },
        validPostDateAndTime: (state, validPostDateAndTime) => {
            state.validPostDateAndTime = validPostDateAndTime;
        }
    }
};

export default new Vuex.Store(options);
export {options}
